module.exports = require("winston-daily-rotate-file");